<template>
    <div class="row">
        <div class="col-md-12 mb-3">
            <el-form label-position="left" label-width="50px">
                <div class="row">
                    <div class="col-12 d-flex flex-column flex-md-row">
                        <div class="me-4 mb-2 mb-md-0">
                            Area: 
                            <el-radio-group v-model="area" size="small" name="area">
                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                            </el-radio-group>
                        </div>
                        <div class="me-3 mb-2 mb-md-0">
                            Tahun:
                            <el-select v-model="year" clearable filterable placeholder="Tahun" size="small" style="width:120px;">
                                <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                </el-option>
                            </el-select> 
                        </div>

                        <el-button type="primary" class="" size="small" :loading="loading.table" @click="applyFilter" style="width:120px;">Apply Filter</el-button>
                    </div>						
                </div>
            </el-form>
        </div>
        <div class="col-md-12">
            <div class="table-sales-tracking-container">
                <table class="table-sales-tracking">
                    <thead class="top-header-1">
                        <tr>
                            <th rowspan="2" style="min-width: 400px; z-index:3;">Unit</th>
                            <th colspan="3">Januari</th>
                            <th colspan="3">Februari</th>
                            <th colspan="3">Maret</th>
                            <th colspan="3">April</th>
                            <th colspan="3">Mei</th>
                            <th colspan="3">Juni</th>
                            <th colspan="3">Juli</th>
                            <th colspan="3">Agustus</th>
                            <th colspan="3">September</th>
                            <th colspan="3">Oktober</th>
                            <th colspan="3">November</th>
                            <th colspan="3">Desember</th>
                            <th rowspan="2">Target YTD</th>
                            <th rowspan="2">Real YTD</th>
                            <th rowspan="2">% Achieved</th>
                        </tr>
                        <tr>
                            <th style="z-index:1;border-radius: 0px;">Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>
                            
                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                            <th>Target</th>
                            <th>Real</th>
                            <th>% Achievement</th>

                        </tr>
                        
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in paginatedData" :key="item.CostCenter +'-'+idx">
                            <td>{{ item.UnitName }}</td>

                            <td class="text-right">{{ formatNum(item.Jan.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Jan.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Jan.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Jan.Achievement)" :style="{ width: parseFloat(item.Jan.Achievement) >= 100 + '%' ? 100 : parseInt(item.Jan.Achievement) + '%' }" :title="formatNum(item.Jan.Achievement)">{{ formatNum(item.Jan.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Feb.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Feb.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Feb.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Feb.Achievement)" :style="{ width: parseFloat(item.Feb.Achievement) >= 100 + '%' ? 100 : parseInt(item.Feb.Achievement) + '%' }" :title="formatNum(item.Feb.Achievement)">{{ formatNum(item.Feb.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Mar.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Mar.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Mar.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Mar.Achievement)" :style="{ width: parseFloat(item.Mar.Achievement) >= 100 + '%' ? 100 : parseInt(item.Mar.Achievement) + '%' }" :title="formatNum(item.Mar.Achievement)">{{ formatNum(item.Mar.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Apr.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Apr.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Apr.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Apr.Achievement)" :style="{ width: parseFloat(item.Apr.Achievement) >= 100 + '%' ? 100 : parseInt(item.Apr.Achievement) + '%' }" :title="formatNum(item.Apr.Achievement)">{{ formatNum(item.Apr.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.May.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.May.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.May.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.May.Achievement)" :style="{ width: parseFloat(item.May.Achievement) >= 100 + '%' ? 100 : parseInt(item.May.Achievement) + '%' }" :title="formatNum(item.May.Achievement)">{{ formatNum(item.May.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Jun.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Jun.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Jun.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Jun.Achievement)" :style="{ width: parseFloat(item.Jun.Achievement) >= 100 + '%' ? 100 : parseInt(item.Jun.Achievement) + '%' }" :title="formatNum(item.Jun.Achievement)">{{ formatNum(item.Jun.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Jul.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Jul.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Jul.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Jul.Achievement)" :style="{ width: parseFloat(item.Jul.Achievement) >= 100 + '%' ? 100 : parseInt(item.Jul.Achievement) + '%' }" :title="formatNum(item.Jul.Achievement)">{{ formatNum(item.Jul.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Aug.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Aug.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Aug.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Aug.Achievement)" :style="{ width: parseFloat(item.Aug.Achievement) >= 100 + '%' ? 100 : parseInt(item.Aug.Achievement) + '%' }" :title="formatNum(item.Aug.Achievement)">{{ formatNum(item.Aug.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Sep.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Sep.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Sep.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Sep.Achievement)" :style="{ width: parseFloat(item.Sep.Achievement) >= 100 + '%' ? 100 : parseInt(item.Sep.Achievement) + '%' }" :title="formatNum(item.Sep.Achievement)">{{ formatNum(item.Sep.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Oct.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Oct.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Oct.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Oct.Achievement)" :style="{ width: parseFloat(item.Oct.Achievement) >= 100 + '%' ? 100 : parseInt(item.Oct.Achievement) + '%' }" :title="formatNum(item.Oct.Achievement)">{{ formatNum(item.Oct.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Nov.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Nov.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Nov.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Nov.Achievement)" :style="{ width: parseFloat(item.Nov.Achievement) >= 100 + '%' ? 100 : parseInt(item.Nov.Achievement) + '%' }" :title="formatNum(item.Nov.Achievement)">{{ formatNum(item.Nov.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.Dec.Target, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.Dec.Real, 2) }}</td>
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.Dec.Achievement) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.Dec.Achievement)" :style="{ width: parseFloat(item.Dec.Achievement) >= 100 + '%' ? 100 : parseInt(item.Dec.Achievement) + '%' }" :title="formatNum(item.Dec.Achievement)">{{ formatNum(item.Dec.Achievement) }}%</div>
                                </div>
                            </td>

                            <td class="text-right">{{ formatNum(item.RkapYtd, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.RealYtd, 2) }}</td>                          
                            <td :class="'text-right font-weight-bold ' + (parseFloat(item.AchievementPercentage) >= 100 ? ' text-success' : ' text-warning ')">
                                <div class="bar-container">
                                    <div :class="barColor(item.AchievementPercentage)" :style="{ width: parseFloat(item.AchievementPercentage) >= 100 + '%' ? 100 : parseInt(item.AchievementPercentage) + '%' }" :title="formatNum(item.AchievementPercentage)">{{ formatNum(item.AchievementPercentage) }}%</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col-md-12 justify-content-end">
                    <!-- Pagination Controls -->
                    <nav aria-label="Page navigation" v-if="totalPages > 1">
                        <ul class="pagination">
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                <a class="page-link btn" @click.prevent="goToPage(1)">First</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                <a class="page-link btn" @click.prevent="prevPage">Previous</a>
                            </li>

                            <!-- Tombol angka -->
                            <li
                            v-for="page in pagesToShow"
                            :key="page"
                            class="page-item page-item-button"
                            :class="{ active: currentPage === page }"
                            >
                                <a class="page-link btn" @click.prevent="goToPage(page)">{{ page }}</a>
                            </li>

                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                <a class="page-link btn" @click.prevent="nextPage">Next</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                <a class="page-link btn" @click.prevent="goToPage(totalPages)">Last</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <Loader v-if="loading.table" />
        </div>
    </div>
</template>


<script>
import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default {
    extends:Fuel,
	components: {
        Loader,
        //BarChart,
        //PieChart,
    },
    props: ['tabIndex','tabName', 'tabLabel'],
    watch:{

    },
    mounted() {
        this.$emit('childrenRoute');
        this.getData();
    },
    data() {
		return {
            reportdata: {
                data: [],
            },
            monthBefore: this.getMonthName(Penanggalan().bulan-1),
            year: Penanggalan().tahun,
            month: Penanggalan().bulan,
            area: '',

            options : {
                area: [
                    { value: '', name: 'All'},
                    { value: '1', name: '1'},
                    { value: '2', name: '2'},
                    { value: '3', name: '3'},
                    { value: '4', name: '4'},
                    { value: '5', name: '5'},
                ],
                years: this.getLastYears(5),
            },

            loading: {
                table: false,
                chart: false,
                isSuccess: false,
            },    

            months: ['jan','feb'],
            currentPage: 1,
            perPage: 10,

            barStrokeWidth: 20,
        }
    },
    methods:{
        async getData() {
            //
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/businesstracking/salesvalue?'

            this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month
			this.urlRequestParams += '&area='+this.area
			
            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        goToPage(page) {
            this.currentPage = page;
        },
        applyFilter() {
            this.getData();
        },
        customTextColor(percentage) {
            if (percentage < 10) {
                return '#5F6165';
            } else {
                return '#ffffff';
            }
        },
        customColorMethod(percentage) {
            if (percentage < 50) {
                return '#F56C6C';
            } else if (percentage < 100) {
                return '#e6a23c';
            } else {
                return '#67c23a';
            }
        },
        barColor(val) {
            let percentage = parseFloat(val);
            if (percentage < 50) {
                return 'bar bar-danger'; //'#F56C6C';
            } else if (percentage < 100) {
                return 'bar bar-warning'; //'#e6a23c';
            } else {
                return 'bar bar-success'; //'#67c23a';
            }
        }
        
       
    },
    computed: {
        totalPages() {
            return Math.ceil(this.reportdata.data.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.reportdata.data.slice(start, start + this.perPage);
        },
        pagesToShow() {
            const pages = [];
            const totalPages = this.totalPages;

            // Logika untuk menampilkan 5 tombol angka
            const startPage = Math.max(1, this.currentPage - 2); // Minimal halaman 1
            const endPage = Math.min(totalPages, startPage + 4); // Maksimal 5 halaman

            // Jika startPage terlalu rendah, sesuaikan
            const adjustedStartPage = Math.max(1, endPage - 4);

            for (let i = adjustedStartPage; i <= endPage; i++) {
                pages.push(i);
            }

            return pages;
        },
    },
}
</script>

<style>
.pagination-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.pagination {
  justify-content: center;
  margin-top: 10px;
}

.page-item {
  cursor: pointer;
}

.page-item-button {
  width: 55px;
  text-align: center;
}

.page-item.disabled .page-link {
  pointer-events: none;
  color: #6c757d; /* Bootstrap gray */
}

.page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}


.bar-container {
    display: flex;
    width: 100%;
    height: 26px;
    background-color: #e0e0e0;
    border-radius: 5px;
    overflow: hidden;
}
.bar {
    height: 100%;
    text-align: center;
    line-height: 26px;
    color: white;
    font-weight: normal;
    font-size:11px;
    padding: 0px 0px;
}
.bar-1 {
    background-color: #67C23A;
    text-align: center;
}
.bar-2 {
    background-color: #909399;
    text-align: center;
}

.bar-success {
    background-color: #67C23A;
    text-align: center;
}

.bar-warning {
    background-color: #E6A23C;
    text-align: center;
}

.bar-danger {
    background-color: #F56C6C;
    text-align: center;
}
</style>